import React from 'react';
import { Button } from '../components/ui/Button';
import { Card, CardHeader, CardBody } from '../components/ui/Card';
import { CtaSection } from '../components/sections/CtaSection';
import { CalendarIcon, MessageSquareIcon, FileTextIcon } from 'lucide-react';
export function Contact() {
  return <div className="pt-20 bg-[#F4E8D0]/30" data-id="element-1376">
      {/* Hero */}
      <section className="bg-[#0099A1] py-20" data-id="element-1377">
        <div className="container mx-auto px-4 md:px-6" data-id="element-1378">
          <div className="max-w-3xl" data-id="element-1379">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-1380">
              Contact Us
            </h1>
            <p className="text-xl text-white/90" data-id="element-1381">
              Ready to go from boardroom to beach? Let's start planning your
              exceptional event.
            </p>
          </div>
        </div>
      </section>

      {/* Contact Options */}
      <section className="py-16 bg-white" data-id="element-1382">
        <div className="container mx-auto px-4 md:px-6" data-id="element-1383">
          <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-1384">
            <h2 className="text-3xl font-bold text-[#374047] mb-4" data-id="element-1385">
              Get in Touch
            </h2>
            <p className="text-lg text-[#374047]/80" data-id="element-1386">
              Choose the method that works best for you. Our team is ready to
              help plan your perfect event.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16 max-w-4xl mx-auto" data-id="element-1387">
            <Card className="text-center h-full" data-id="element-1388">
              <CardHeader className="flex flex-col items-center" data-id="element-1389">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#0099A1]/10 mb-4" data-id="element-1390">
                  <CalendarIcon className="h-8 w-8 text-[#0099A1]" data-id="element-1391" />
                </div>
                <h3 className="text-xl font-bold text-[#374047]" data-id="element-1392">
                  Book a Call
                </h3>
              </CardHeader>
              <CardBody data-id="element-1393">
                <p className="text-[#374047]/80 mb-6" data-id="element-1394">
                  Schedule a 15-minute discovery call with our team to discuss
                  your event needs.
                </p>
                <Button variant="primary" href="https://calendar.app.google/FGeh6NzZCtuDUMjV9" target="_blank" rel="noopener noreferrer" data-id="element-1395">
                  Book Discovery Call
                </Button>
              </CardBody>
            </Card>
            <Card className="text-center h-full" data-id="element-1396">
              <CardHeader className="flex flex-col items-center" data-id="element-1397">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#0099A1]/10 mb-4" data-id="element-1398">
                  <MessageSquareIcon className="h-8 w-8 text-[#0099A1]" data-id="element-1399" />
                </div>
                <h3 className="text-xl font-bold text-[#374047]" data-id="element-1400">WhatsApp</h3>
              </CardHeader>
              <CardBody data-id="element-1401">
                <p className="text-[#374047]/80 mb-6" data-id="element-1402">
                  Connect with us instantly via WhatsApp for quick questions and
                  inquiries.
                </p>
                <Button variant="outline" className="bg-[#25D366] text-white border-[#25D366] hover:bg-[#25D366]/90" href="https://api.whatsapp.com/send?phone=19052152109" target="_blank" rel="noopener noreferrer" data-id="element-1403">
                  Start WhatsApp Chat
                </Button>
              </CardBody>
            </Card>
            <Card className="text-center h-full" data-id="element-1404">
              <CardHeader className="flex flex-col items-center" data-id="element-1405">
                <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#0099A1]/10 mb-4" data-id="element-1406">
                  <FileTextIcon className="h-8 w-8 text-[#0099A1]" data-id="element-1407" />
                </div>
                <h3 className="text-xl font-bold text-[#374047]" data-id="element-1408">
                  Request Proposal
                </h3>
              </CardHeader>
              <CardBody data-id="element-1409">
                <p className="text-[#374047]/80 mb-6" data-id="element-1410">
                  Fill out our detailed form and we'll create a custom plan for
                  your event.
                </p>
                <Button variant="primary" href="https://form.typeform.com/to/QUkK2HU7" target="_blank" rel="noopener noreferrer" data-id="element-1411">
                  Book Discovery Call
                </Button>
              </CardBody>
            </Card>
          </div>
        </div>
      </section>

      <CtaSection data-id="element-1412" />
    </div>;
}